import React from 'react';
import AdminDocuments from './../../../documents/tenants/admin';
import { history } from '../../../../configuration/store';

class AdminOnboarding extends React.Component {
    render() {
        return (
            <div className="page">
                <AdminDocuments externalOnCompleteCallback={() => history.push('/')} />
            </div>
        );
    }
}

export default AdminOnboarding;



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/admin/index.jsx